module.exports = __webpack_public_path__ + "static/media/ally-II-logo-pwa@3x.e11ce21d.jpg";